import { render, staticRenderFns } from "./CompProfileEditBasicInformation.vue?vue&type=template&id=69a8a95e&scoped=true"
import script from "./CompProfileEditBasicInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditBasicInformation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a8a95e",
  null
  
)

export default component.exports